document.addEventListener('DOMContentLoaded', function () {
  var lang = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);

  var copy = {
    de: {
      benefitsEyebrow: 'Warum Swiss Nutri',
      benefitsHeading: 'Klare Vorteile für ein einfacheres Einkaufserlebnis.',
      brandTitle: 'Seit 2013 in der Schweiz entwickelt.',
      brandText: 'Swiss Nutri GmbH mit Sitz in der Schweiz. Über 60’000 Kundinnen und Kunden.',
      reviewTitle: '4.8/5 Sterne',
      reviewText: 'Basierend auf 236 Kundenbewertungen auf Judge.me.',
      shippingTitle: 'Kostenloser Versand ab CHF 120.–',
      shippingText: 'Swiss Post Express: Versand am selben Tag, Lieferung in 1–2 Werktagen in CH/LI.',
      carefullyTitle: 'Sorgfältig ausgewählt',
      carefullyText: 'Unsere Formulierungen basieren auf einer bewusst abgestimmten Auswahl an Inhaltsstoffen.',
      paymentTitle: 'Kauf auf Rechnung.',
      paymentText: 'TWINT · PayPal · Kreditkarte · Rechnung (14 Tage). Sicher verschlüsselt.',
      satisfactionTitle: 'Zufriedenheitsgarantie',
      satisfactionText: 'Wenn etwas nicht passt, finden wir gemeinsam eine passende Lösung.',
      announcementExpress: 'Express mit Swiss Post',
      announcementExpressDetail: 'bis 14:00 Uhr bestellen',
      announcementSecure: 'Sicher bestellen',
      announcementShipping: 'Kostenloser Versand ab CHF 120.–'
    },
    en: {
      benefitsEyebrow: 'Why Swiss Nutri',
      benefitsHeading: 'Clear advantages that make shopping simpler.',
      brandTitle: 'Developed in Switzerland since 2013.',
      brandText: 'Swiss Nutri GmbH, based in Switzerland. Over 60,000 customers.',
      reviewTitle: '4.8/5 stars',
      reviewText: 'Based on 236 customer reviews on Judge.me.',
      shippingTitle: 'Free shipping from CHF 120.–',
      shippingText: 'Swiss Post Express: Same-day dispatch, delivery in 1–2 working days in CH/LI.',
      carefullyTitle: 'Carefully selected',
      carefullyText: 'Our formulations use a thoughtfully balanced selection of ingredients.',
      paymentTitle: 'Purchase on account.',
      paymentText: 'TWINT · PayPal · Credit card · Invoice (14 days). Securely encrypted.',
      satisfactionTitle: 'Satisfaction guarantee',
      satisfactionText: 'If something is not right for you, we will work with you to find a suitable solution.',
      announcementExpress: 'Express with Swiss Post',
      announcementExpressDetail: 'order by 14:00',
      announcementSecure: 'Secure ordering',
      announcementShipping: 'Free shipping from CHF 120.–'
    },
    fr: {
      benefitsEyebrow: 'Pourquoi Swiss Nutri',
      benefitsHeading: 'Des avantages clairs pour simplifier votre expérience d’achat.',
      brandTitle: 'Développé en Suisse depuis 2013.',
      brandText: 'Swiss Nutri GmbH, basée en Suisse. Plus de 60 000 clients.',
      reviewTitle: '4,8/5 étoiles',
      reviewText: 'D’après 236 avis clients sur Judge.me.',
      shippingTitle: 'Livraison gratuite dès CHF 120.–',
      shippingText: 'Swiss Post Express : expédition le jour même, livraison en 1 à 2 jours ouvrables en CH/LI.',
      carefullyTitle: 'Sélection soignée',
      carefullyText: 'Nos formulations reposent sur une sélection d’ingrédients soigneusement équilibrée.',
      paymentTitle: 'Achat sur facture.',
      paymentText: 'TWINT · PayPal · Carte de crédit · Facture (14 jours). Paiement sécurisé et chiffré.',
      satisfactionTitle: 'Garantie de satisfaction',
      satisfactionText: 'Si quelque chose ne vous convient pas, nous chercherons avec vous une solution adaptée.',
      announcementExpress: 'Express avec Swiss Post',
      announcementExpressDetail: 'commande avant 14 h',
      announcementSecure: 'Commande sécurisée',
      announcementShipping: 'Livraison gratuite dès CHF 120.–'
    },
    it: {
      benefitsEyebrow: 'Perché Swiss Nutri',
      benefitsHeading: 'Vantaggi chiari per un acquisto più semplice.',
      brandTitle: 'Sviluppato in Svizzera dal 2013.',
      brandText: 'Swiss Nutri GmbH, con sede in Svizzera. Oltre 60’000 clienti.',
      reviewTitle: '4,8/5 stelle',
      reviewText: 'Sulla base di 236 recensioni dei clienti su Judge.me.',
      shippingTitle: 'Spedizione gratuita da CHF 120.–',
      shippingText: 'Swiss Post Express: spedizione in giornata, consegna in 1–2 giorni lavorativi in CH/LI.',
      carefullyTitle: 'Selezionati con cura',
      carefullyText: 'Le nostre formulazioni si basano su una selezione di ingredienti attentamente bilanciata.',
      paymentTitle: 'Acquisto su fattura.',
      paymentText: 'TWINT · PayPal · Carta di credito · Fattura (14 giorni). Pagamento sicuro e crittografato.',
      satisfactionTitle: 'Garanzia di soddisfazione',
      satisfactionText: 'Se qualcosa non dovesse essere adatto a Lei, cercheremo insieme una soluzione appropriata.',
      announcementExpress: 'Express con Swiss Post',
      announcementExpressDetail: 'ordini entro le 14:00',
      announcementSecure: 'Acquisti in sicurezza',
      announcementShipping: 'Spedizione gratuita da CHF 120.–'
    }
  };

  var selected = copy[lang] || copy.en;

  var grid = document.querySelector('.sn-home .sn-feature-grid');
  if (grid) {
    var cards = grid.querySelectorAll('article');

    if (cards.length >= 6) {
      var brandCard = cards[0];
      var reviewCard = cards[1];
      var freeShippingCard = cards[2];
      var carefullySelectedCard = cards[3];
      var paymentCard = cards[4];
      var satisfactionCard = cards[5];

      var carefullySelectedIcon = reviewCard.querySelector('.sn-cross-badge img');
      var carefullySelectedIconSrc = carefullySelectedIcon ? (carefullySelectedIcon.currentSrc || carefullySelectedIcon.src) : '';
      var carefullySelectedIconSrcset = carefullySelectedIcon ? carefullySelectedIcon.srcset : '';
      var targetIcon = carefullySelectedCard.querySelector('.sn-cross-badge img');

      if (targetIcon && carefullySelectedIconSrc) {
        targetIcon.src = carefullySelectedIconSrc;
        targetIcon.srcset = carefullySelectedIconSrcset;
        targetIcon.alt = '';
      }

      var brandTitle = brandCard.querySelector('h3');
      var brandText = brandCard.querySelector('p');
      if (brandTitle) brandTitle.textContent = selected.brandTitle;
      if (brandText) brandText.textContent = selected.brandText;

      var reviewTitle = reviewCard.querySelector('h3');
      var reviewText = reviewCard.querySelector('p');
      if (reviewTitle) reviewTitle.textContent = selected.reviewTitle;
      if (reviewText) reviewText.textContent = selected.reviewText;

      var starsIcon = document.querySelector('.sn-usp-strip__grid article:nth-child(3) .sn-cross-badge img');
      if (carefullySelectedIcon && starsIcon) {
        carefullySelectedIcon.src = starsIcon.currentSrc || starsIcon.src;
        carefullySelectedIcon.srcset = starsIcon.srcset;
        carefullySelectedIcon.alt = '';
      }

      var freeShippingTitle = freeShippingCard.querySelector('h3');
      var freeShippingText = freeShippingCard.querySelector('p');
      var freeShippingIcon = freeShippingCard.querySelector('.sn-cross-badge img');
      var paymentIcon = paymentCard.querySelector('.sn-cross-badge img');
      if (freeShippingTitle) freeShippingTitle.textContent = selected.shippingTitle;
      if (freeShippingText) freeShippingText.textContent = selected.shippingText;
      if (freeShippingIcon && paymentIcon) {
        freeShippingIcon.src = paymentIcon.currentSrc || paymentIcon.src;
        freeShippingIcon.srcset = paymentIcon.srcset;
        freeShippingIcon.alt = '';
      }

      var carefullyTitle = carefullySelectedCard.querySelector('h3');
      var carefullyText = carefullySelectedCard.querySelector('p');
      if (carefullyTitle) carefullyTitle.textContent = selected.carefullyTitle;
      if (carefullyText) carefullyText.textContent = selected.carefullyText;

      var paymentTitle = paymentCard.querySelector('h3');
      var paymentText = paymentCard.querySelector('p');
      if (paymentTitle) paymentTitle.textContent = selected.paymentTitle;
      if (paymentText) paymentText.textContent = selected.paymentText;

      var satisfactionTitle = satisfactionCard.querySelector('h3');
      var satisfactionText = satisfactionCard.querySelector('p');
      if (satisfactionTitle) satisfactionTitle.textContent = selected.satisfactionTitle;
      if (satisfactionText) satisfactionText.textContent = selected.satisfactionText;

      var benefitsSection = grid.closest('section');
      if (benefitsSection) {
        var benefitsEyebrow = benefitsSection.querySelector('.sn-heading .sn-eyebrow');
        var benefitsHeading = benefitsSection.querySelector('.sn-heading h2');
        if (benefitsEyebrow) {
          var eyebrowIcon = benefitsEyebrow.querySelector('i');
          benefitsEyebrow.textContent = selected.benefitsEyebrow;
          if (eyebrowIcon) benefitsEyebrow.insertBefore(eyebrowIcon, benefitsEyebrow.firstChild);
        }
        if (benefitsHeading) benefitsHeading.textContent = selected.benefitsHeading;
      }
    }
  }

  var announcement = document.querySelector('.sn-announcement');
  if (announcement) {
    var announcementItems = announcement.querySelectorAll('.sn-announcement__item');

    if (announcementItems[0]) {
      var expressText = announcementItems[0].querySelectorAll(':scope > span:not(.sn-announcement__icon)');
      if (expressText[0]) expressText[0].textContent = selected.announcementExpress;
      if (expressText[1]) expressText[1].textContent = '· ' + selected.announcementExpressDetail;
    }

    if (announcementItems[1]) {
      var secureText = announcementItems[1].querySelector(':scope > span:not(.sn-announcement__icon)');
      if (secureText) secureText.textContent = selected.announcementSecure;
    }

    if (announcementItems[2]) {
      var shippingText = announcementItems[2].querySelectorAll(':scope > span:not(.sn-announcement__icon)');
      if (shippingText[0]) shippingText[0].textContent = selected.announcementShipping;
    }
  }

  var ratingText = {
    de: '4.8/5 Sterne',
    en: '4.8/5 stars',
    fr: '4,8/5 étoiles',
    it: '4,8/5 stelle'
  }[lang] || '4.8/5 stars';

  var shortRating = {
    de: '4.8/5',
    en: '4.8/5',
    fr: '4,8/5',
    it: '4,8/5'
  }[lang] || '4.8/5';

  var heroRating = document.querySelector('.sn-trust span:first-child strong');
  if (heroRating) heroRating.textContent = shortRating;

  var topUspRating = document.querySelector('.sn-usp-strip__grid article:nth-child(3) strong');
  if (topUspRating) topUspRating.textContent = ratingText;

  var storyRating = document.querySelector('.sn-stats span:nth-child(3) b');
  if (storyRating) storyRating.textContent = shortRating;

  var testimonialRating = document.querySelector('.sn-rating-summary strong');
  if (testimonialRating) testimonialRating.textContent = shortRating;

  var ratingBadgeMarkup = '<svg viewBox="0 0 64 64" width="48" height="48" aria-hidden="true" focusable="false"><path fill="currentColor" d="M32 7.5l7.3 14.8 16.3 2.4-11.8 11.5 2.8 16.2L32 44.7l-14.6 7.7 2.8-16.2L8.4 24.7l16.3-2.4L32 7.5z"></path><text x="32" y="58" text-anchor="middle" font-size="10" font-weight="700" fill="currentColor">' + shortRating + '</text></svg>';

  var topRatingBadge = document.querySelector('.sn-usp-strip__grid article:nth-child(3) .sn-cross-badge');
  if (topRatingBadge) {
    topRatingBadge.innerHTML = ratingBadgeMarkup;
    topRatingBadge.style.color = '#ffffff';
  }

  var benefitRatingBadge = document.querySelector('.sn-feature-grid article:nth-child(2) .sn-cross-badge');
  if (benefitRatingBadge) {
    benefitRatingBadge.innerHTML = ratingBadgeMarkup;
    benefitRatingBadge.style.color = '#ffffff';
  }
});
